module.exports = __webpack_public_path__ + "static/media/MODO_ALMACEN.cf4a5b42.jpg";